function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import * as React from "react";
import DatePicker, { registerLocale } from "react-datepicker";
import { Block } from "../library/container";
import { nl } from "./datepickerUtils";
import { submitForm } from "./newsletterFormBlockApi";
import { allFields, branches, genderLabels, genderValues, initialState, newsletterLabels, newsletters, setFieldOnState, setVisited, toggleNewsletterOnState, validateFields, validateFormData } from "./newsletterFormBlockState";
const debounce = require("lodash.debounce");
import { Loader } from "../loader";
import { Link } from "../library/link";
import { slugify } from "../../../custom_utils/helpers";
registerLocale("nl", nl);
export class NewsletterFormBlock extends React.Component {
    submit() {
        const validationMessages = validateFields(allFields, this.state.data);
        if (validationMessages.count() > 0) {
            this.setState((prevState)=>({
                    ...prevState,
                    validationMessages
                }));
            const offsetForm = document.getElementById("newsletter-form").offsetTop;
            window.scrollTo({
                top: offsetForm - 100,
                behavior: 'smooth'
            });
            return;
        }
        this.setState((prevState)=>({
                ...prevState,
                status: "submitting"
            }), async ()=>{
            const status = await submitForm(this.state.data) ? "succeeded" : "failed";
            this.setState((prevState)=>({
                    ...prevState,
                    status
                }));
        });
    }
    hasError(field) {
        const messages = this.state.validationMessages;
        return messages.has(field) ? true : false;
    }
    maybeShowMessage(field) {
        const messages = this.state.validationMessages;
        return messages.has(field) ? /*#__PURE__*/ _jsx("p", {
            id: `nfd-${field}`,
            className: "form__description form__error",
            children: messages.get(field)
        }) : /*#__PURE__*/ _jsx(_Fragment, {});
    }
    render() {
        if (this.state.status == "submitting") return submitting;
        if (this.state.status == "succeeded") return succeeded;
        if (this.state.status == "failed") return failed;
        const setField = setFieldOnState(this.setState.bind(this));
        const set = (field)=>(e)=>{
                setField(field)(e.target.value);
                this.validateVisitedAfterDelay();
            };
        const toggler = toggleNewsletterOnState(this.setState.bind(this));
        const toggleNewsletter = (newsletter)=>{
            toggler(newsletter);
            this.validateVisitedAfterDelay();
        };
        const setVisit = setVisited(this.setState.bind(this));
        const visit = (field)=>()=>setVisit(field);
        const { firstName, initials, infix, lastName, emailAddress, dateOfBirth, gender, branch, newsletters: selectedNewsletters } = this.state.data;
        return /*#__PURE__*/ _jsx(Block, {
            children: /*#__PURE__*/ _jsxs("div", {
                id: "newsletter-form",
                className: "newsletter-form",
                children: [
                    /*#__PURE__*/ _jsxs("fieldset", {
                        children: [
                            /*#__PURE__*/ _jsx("legend", {
                                className: "form__title title--ms",
                                children: "Persoonlijke informatie"
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "form__group form__group--name",
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "form__field form__field--long",
                                        children: [
                                            /*#__PURE__*/ _jsx("label", {
                                                className: "form__label",
                                                htmlFor: "firstName",
                                                children: "Voornaam"
                                            }),
                                            /*#__PURE__*/ _jsx("input", {
                                                id: "firstName",
                                                className: "form__input",
                                                name: "firstName",
                                                type: "text",
                                                onFocus: visit("firstName"),
                                                onChange: set("firstName"),
                                                value: firstName,
                                                autoComplete: "given-name",
                                                "aria-invalid": this.hasError("firstName") ? true : undefined,
                                                "aria-errormessage": this.hasError("firstName") ? `nfd-firstName` : undefined
                                            }),
                                            this.maybeShowMessage("firstName")
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "form__field form__field--short",
                                        children: [
                                            /*#__PURE__*/ _jsx("label", {
                                                className: "form__label form__label--required",
                                                htmlFor: "initials",
                                                children: "Voorletters"
                                            }),
                                            /*#__PURE__*/ _jsx("input", {
                                                id: "initials",
                                                className: "form__input",
                                                name: "initials",
                                                type: "text",
                                                onFocus: visit("initials"),
                                                onChange: set("initials"),
                                                value: initials,
                                                "aria-invalid": this.hasError("initials") ? true : undefined,
                                                "aria-errormessage": this.hasError("initials") ? `nfd-initials` : undefined,
                                                "aria-required": true,
                                                autoComplete: "on"
                                            }),
                                            this.maybeShowMessage("initials")
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "form__field name form__field--short",
                                        children: [
                                            /*#__PURE__*/ _jsx("label", {
                                                className: "form__label",
                                                htmlFor: "infix",
                                                children: "Tussenvoegsel"
                                            }),
                                            /*#__PURE__*/ _jsx("input", {
                                                id: "infix",
                                                className: "form__input",
                                                name: "infix",
                                                type: "text",
                                                onFocus: visit("infix"),
                                                onChange: set("infix"),
                                                autoComplete: "on",
                                                value: infix
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "form__field form__field--long",
                                        children: [
                                            /*#__PURE__*/ _jsx("label", {
                                                className: "form__label form__label--required",
                                                htmlFor: "lastName",
                                                children: "Achternaam"
                                            }),
                                            /*#__PURE__*/ _jsx("input", {
                                                id: "lastName",
                                                className: "form__input",
                                                name: "lastName",
                                                type: "text",
                                                onFocus: visit("lastName"),
                                                onChange: set("lastName"),
                                                value: lastName,
                                                autoComplete: "family-name",
                                                "aria-invalid": this.hasError("lastName") ? true : undefined,
                                                "aria-errormessage": this.hasError("lastName") ? `nfd-lastName` : undefined,
                                                "aria-required": true
                                            }),
                                            this.maybeShowMessage("lastName")
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "form__field",
                                children: [
                                    /*#__PURE__*/ _jsx("label", {
                                        className: "form__label form__label--required",
                                        htmlFor: "emailAddress",
                                        children: "E-mailadres"
                                    }),
                                    /*#__PURE__*/ _jsx("input", {
                                        id: "emailAddress",
                                        className: "form__input",
                                        name: "emailAddress",
                                        type: "email",
                                        onFocus: visit("emailAddress"),
                                        onChange: set("emailAddress"),
                                        value: emailAddress,
                                        autoComplete: "email",
                                        "aria-invalid": this.hasError("emailAddress") ? true : undefined,
                                        "aria-errormessage": this.hasError("emailAddress") ? `nfd-emailAddress` : undefined,
                                        "aria-required": true
                                    }),
                                    this.maybeShowMessage("emailAddress")
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "form__field",
                                children: [
                                    /*#__PURE__*/ _jsx("label", {
                                        className: "form__label",
                                        htmlFor: "dateOfBirth",
                                        children: "Geboortedatum"
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "form__date",
                                        children: [
                                            /*#__PURE__*/ _jsx(DatePicker, {
                                                id: "dateOfBirth",
                                                locale: "nl",
                                                selected: dateOfBirth,
                                                onChange: (e)=>{
                                                    setField("dateOfBirth")(e || new Date());
                                                },
                                                dateFormat: "d MMMM, yyyy",
                                                peekNextMonth: true,
                                                showMonthDropdown: true,
                                                showYearDropdown: true,
                                                dropdownMode: "select",
                                                autoComplete: "bday"
                                            }),
                                            /*#__PURE__*/ _jsx("svg", {
                                                width: "15",
                                                height: "17",
                                                "aria-hidden": "true",
                                                children: /*#__PURE__*/ _jsx("use", {
                                                    xlinkHref: "#icon--calendar"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "form__field",
                                children: [
                                    /*#__PURE__*/ _jsx("label", {
                                        className: "form__label",
                                        children: "Geslacht"
                                    }),
                                    genderValues.map((g)=>/*#__PURE__*/ _jsxs("div", {
                                            className: "form__radio",
                                            children: [
                                                /*#__PURE__*/ _jsx("input", {
                                                    id: g,
                                                    type: "radio",
                                                    name: "gender",
                                                    value: g,
                                                    checked: gender == g,
                                                    onChange: ()=>setField("gender")(g)
                                                }),
                                                /*#__PURE__*/ _jsxs("label", {
                                                    htmlFor: g,
                                                    children: [
                                                        /*#__PURE__*/ _jsx("span", {
                                                            className: "sr-text",
                                                            children: "Geslacht "
                                                        }),
                                                        genderLabels[g]
                                                    ]
                                                })
                                            ]
                                        }, g))
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "form__field",
                                children: [
                                    /*#__PURE__*/ _jsx("label", {
                                        className: "form__label",
                                        htmlFor: "branch",
                                        children: "Hoofdvestiging"
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "form__select",
                                        children: /*#__PURE__*/ _jsx("select", {
                                            id: "branch",
                                            name: "branch",
                                            value: branch,
                                            onFocus: visit("branch"),
                                            onChange: (e)=>setField("branch")(e.target.value),
                                            children: branches.map((branch)=>/*#__PURE__*/ _jsx("option", {
                                                    label: branch,
                                                    value: branch,
                                                    children: branch
                                                }, branch))
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "form__field",
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "form__label",
                                        children: [
                                            "Ik wil me inschrijven voor de",
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "form__label--required"
                                            })
                                        ]
                                    }),
                                    newsletters.map((newsletter)=>/*#__PURE__*/ _jsxs("div", {
                                            className: "form__check",
                                            children: [
                                                /*#__PURE__*/ _jsx("input", {
                                                    id: slugify(newsletter),
                                                    type: "checkbox",
                                                    name: newsletter,
                                                    value: newsletter,
                                                    checked: selectedNewsletters.includes(newsletter),
                                                    onChange: ()=>toggleNewsletter(newsletter),
                                                    "aria-invalid": this.hasError("newsletters") ? true : undefined,
                                                    "aria-errormessage": this.hasError("newsletters") ? `nfd-newsletters` : undefined,
                                                    "aria-describedby": `nfd-${slugify(newsletter)}`
                                                }),
                                                /*#__PURE__*/ _jsx("label", {
                                                    htmlFor: slugify(newsletter),
                                                    children: newsletter
                                                }),
                                                /*#__PURE__*/ _jsx("p", {
                                                    id: `nfd-${slugify(newsletter)}`,
                                                    className: "form__description",
                                                    children: newsletterLabels[newsletter]
                                                })
                                            ]
                                        }, newsletter)),
                                    this.maybeShowMessage("newsletters")
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("p", {
                        className: "form__label--required--legend",
                        children: "* Vereist"
                    }),
                    /*#__PURE__*/ _jsx("button", {
                        className: "button",
                        onMouseOver: ()=>this.validate(true),
                        onClick: ()=>this.submit(),
                        children: "Verstuur"
                    })
                ]
            })
        });
    }
    constructor(props){
        super(props), _define_property(this, "validate", validateFormData(this.setState.bind(this))), _define_property(this, "validateVisitedAfterDelay", debounce(()=>this.validate(), 1000));
        this.state = initialState;
    }
}
const submitting = /*#__PURE__*/ _jsx(Block, {
    children: /*#__PURE__*/ _jsxs("div", {
        className: "newsletter-form newsletter-form--submitting",
        children: [
            /*#__PURE__*/ _jsx("h2", {
                className: "form__title title--ms",
                children: "Bezig met versturen"
            }),
            /*#__PURE__*/ _jsx(Loader, {})
        ]
    })
});
const succeeded = /*#__PURE__*/ _jsx(Block, {
    children: /*#__PURE__*/ _jsxs("div", {
        className: "newsletter-form newsletter-form--succeeded",
        children: [
            /*#__PURE__*/ _jsx("h2", {
                className: "form__title title--ms",
                children: "Inschrijving verstuurd"
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "text--styled",
                children: /*#__PURE__*/ _jsx("p", {
                    children: "Bedankt voor het aanmelden voor de nieuwsbrief! We hebben je gegevens verwerkt zodat je de nieuwsbrief binnenkort ontvangt."
                })
            })
        ]
    })
});
const failed = /*#__PURE__*/ _jsx(Block, {
    children: /*#__PURE__*/ _jsxs("div", {
        className: "newsletter-form newsletter-form--failed",
        children: [
            /*#__PURE__*/ _jsx("h2", {
                className: "form__title title--ms",
                children: "Het inschrijven is mislukt"
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "text--styled",
                children: [
                    /*#__PURE__*/ _jsx("p", {
                        children: "Er is iets misgegaan tijdens het aanmelden voor de nieuwsbrief. Herlaadt deze pagina en probeer het nog eens."
                    }),
                    /*#__PURE__*/ _jsxs("p", {
                        children: [
                            "Lukt het nog steeds niet? Neem dan ",
                            /*#__PURE__*/ _jsx(Link, {
                                url: "/klantenservice",
                                children: "contact"
                            }),
                            " met ons op."
                        ]
                    })
                ]
            })
        ]
    })
});
